/**
 * The unified "Shipments" section shows ONE user category, "In work", for the three server states PICKING, PICKED and PACKED.
 * It is only a filter / label on the client: the server state machine is unchanged and every order keeps its real state.
 */
export const IN_WORK_STATES = ['PICKING', 'PICKED', 'PACKED'] as const;
export const IN_WORK_GROUP = IN_WORK_STATES.join(',');

export function isInWork(state: string): boolean {
  return (IN_WORK_STATES as readonly string[]).includes(state);
}
